import React, { useEffect, useState } from 'react'
import {
  Tab,
  Tabs,
  Box,
  Typography,
  MenuItem,
  FormControl,
  Select,
  InputLabel
} from '@mui/material'
import DescriptionIcon from '@mui/icons-material/Description' // For Application Form
import HistoryEduIcon from '@mui/icons-material/HistoryEdu' // For Loss Run
import AssignmentIcon from '@mui/icons-material/Assignment' // For Coverage Form
import AnalysisSection from './AnalysisSection'
import { useSelector } from 'react-redux'
// import CircularProgress from '@mui/material/CircularProgress';

// Tab panel component to render content based on active tab
function TabPanel (props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

// Custom Progress Circle Component
const ProgressCircle = ({ securedScore }) => {
  const percent = (securedScore / 10) * 100

  const radius = 40 // Radius of the circle
  const strokeWidth = 8 // Stroke width
  const normalizedRadius = radius - strokeWidth * 0.5
  const circumference = normalizedRadius * 2 * Math.PI
  const strokeDashoffset = circumference - (percent / 100) * circumference

  // Dynamic color based on percentage
  let strokeColor
  if (percent >= 80) {
    strokeColor = '#00cc00' // Green for >= 75%
  } else if (percent >= 50) {
    strokeColor = '#ff9900' // Yellow for >= 50%
  } else {
    strokeColor = '#ff0000' // Red for < 50%
  }

  return (
    <svg
      height={radius * 2}
      width={radius * 2}
      style={{ filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))' }}
    >
      {/* Background Circle */}
      <circle
        stroke='#e6e6e6' // Light grey background
        fill='transparent'
        strokeWidth={strokeWidth}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />

      {/* Progress Circle with gradient */}
      <circle
        stroke={strokeColor} // Dynamic stroke color based on percentage
        fill='transparent'
        strokeWidth={strokeWidth}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
        strokeDasharray={circumference + ' ' + circumference}
        strokeDashoffset={strokeDashoffset}
        style={{
          transition: 'stroke-dashoffset 0.5s ease 0s, stroke 0.5s ease',
          strokeLinecap: 'round' // Rounded edges
        }}
      />

      {/* Central Text */}
      <text
        x='50%'
        y='50%'
        textAnchor='middle'
        fill={strokeColor}
        dy='.3em'
        fontSize='1.2em'
        fontWeight='bold'
      >
        {`${securedScore}/10`}
      </text>
    </svg>
  )
}

const AppetiteSummaryTabs = () => {
  const selectedApplicationDetails = useSelector(
    state => state.intakeData?.selectedApplicationData
  )
  const [value, setValue] = useState(0)
  const [menuItems, setMenuItems] = useState([])
  const [selectedLob, setSelectedLob] = useState('')
  const [securedScore, setSecuredScore] = useState(0)
  const [appSummary, setAppSummary] = useState('')
  useEffect(() => {
    const lobs = selectedApplicationDetails?.lob || ''
    const lobArray = lobs.split(',')
    setMenuItems(lobArray)
    setSelectedLob(lobArray[0])
  }, [selectedApplicationDetails])

  const handleChange = (event, newValue) => {
    setSelectedLob(event.target.value)
  }

  return (
    <Box className='w-full appetite-summary'>
      <div className='flex justify-between gap-2 mt-4'>
        <h1 className='text-2xl'>Decision Grid</h1>
        <div className='switch-lob'>
          <label className='mr-4 font-bold'>Switch LOB </label>
          <FormControl className='w-64' variant='outlined'>
            {/* Adjusted width to w-48 (12rem, which is 30% smaller than w-64) */}
            {/* <InputLabel id='lob-select-label' className='text-gray-700'>
              Management Liability Insurance
            </InputLabel> */}
            <Select
              labelId='lob-select-label'
              value={selectedLob}
              onChange={handleChange}
              className='bg-white'
            >
              {menuItems.map((item, index) => (
                <MenuItem key={index} value={item.trim()}>
                  {item.trim()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      {/* Tabs for navigation */}
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label='Appetite Tabs'
        className='appetite-tabs'
      >
        <Tab label='Appetite' icon={<DescriptionIcon />} />
        <Tab label='Pricing Worksheet' icon={<HistoryEduIcon />} />
        <Tab label='Quote Review' icon={<AssignmentIcon />} />
      </Tabs>

      {/* Tab panel content */}
      <TabPanel value={value} index={0} className='appetite-content'>
        <Box className='flex gap-4'>
          {/* First section: Appetite Summary */}
          <Box className='w-1/3 p-4 appetite-content-details'>
            <Typography>
              <b>Line of Business:</b> {selectedLob || 'N/A'}
            </Typography>
            <Typography>
              <b>Appetite Status:</b>{' '}
              {selectedApplicationDetails?.appetite_additional_1?.[
                'AppetiteStatus'
              ] || 'N/A'}
            </Typography>
          </Box>

          {/* Second section: Progress Circle */}
          {securedScore !== undefined && (
            <Box className='w-1/4 flex items-center justify-center'>
              <ProgressCircle securedScore={securedScore} />
            </Box>
          )}

          {/* Third section: Content */}
          <Box className='w-1/3 p-4'>
            <Typography variant='body2'>{appSummary || ''}</Typography>
          </Box>
        </Box>
        <AnalysisSection
          selectedLob={selectedLob || menuItems[0]}
          setSecuredScore={setSecuredScore}
          setAppSummary={setAppSummary}
        />
        {/* <div class="flex mt-6 mr-4 justify-end space-x-4">
          <CircularProgress color="success" />
        </div> */}
      </TabPanel>

      {/* Pricing Worksheet Tab */}
      <TabPanel value={value} index={1}>
        Pricing Worksheet Content Goes Here
      </TabPanel>

      {/* Quote Review Tab */}
      <TabPanel value={value} index={2}>
        Quote Review Content Goes Here
      </TabPanel>
    </Box>
  )
}

export default AppetiteSummaryTabs
